import $ from "jquery";
// require("jquery-easing");
import { TweenMax, Power1 } from "gsap";
import { isNotPC } from "./ua";


export default class Slide {
  constructor() {
    this.max = 4;
    this.index = 0;
    this.$current = null;

    const ua = navigator.userAgent.toLowerCase();
    this.isSafari = (ua.indexOf("safari") > -1) && (ua.indexOf("chrome") === -1) && (ua.indexOf("macintosh") > -1);
    console.log(ua);
  }

  init(callback) {
    const image = new Image();
    image.onload = () => {
      callback.call();

      const id = "#js-slide-item0";
      this.$current = $(id);
      this.$container = $("#js-slide-images");

      if (this.isSafari) {
        TweenMax.fromTo(id, 10,
          {width: "120%", height: "120%", top: "-10%", left: "-10%"},
          {width: "100%", height: "100%", top: "0%", left: "0%", ease: Power1.easeOut, delay: 1}
        );
      } else {
        TweenMax.fromTo(id, 10,
          {scale: 1.2},
          {scale: 1, ease: Power1.easeOut}
        );
      }

      setTimeout(() => {
        this.next();
      }, 7000);

    };
    image.src = "/assets/img/sp/top-image1.jpg";
  }

  next() {
    this.index++;

    if (this.index >= this.max) {
      this.index = 0;
    }

    let url = `/assets/img/top-image${this.index + 1}.jpg`;

    if (isNotPC()) {
      url = `/assets/img/sp/top-image${this.index + 1}.jpg`;
    }

    this.newImage = new Image();
    this.newImage.onload = () => {
      this.showNext();
    };
    this.newImage.src = url;
  }

  showNext() {
    const id = "js-slide-item" + this.index;
    // const $el = $(`<div class="images__item rellax-pc" data-rellax-speed="-4" id="${id}"></div>`);
    const $el = $(`<div class="images__item" id="${id}"></div>`);
    $el.css({"background-image": `url(${this.newImage.src})`});

    this.$container.prepend($el);

    if (this.isSafari) {
      TweenMax.fromTo(`#${id}`, 10,
        {width: "120%", height: "120%", top: "-10%", left: "-10%"},
        {width: "100%", height: "100%", top: "0%", left: "0%", ease: Power1.easeOut, delay: 1}
      );
    } else {
      TweenMax.fromTo(`#${id}`, 10,
        {scale: 1.2},
        {scale: 1, ease: Power1.easeOut}
      );
    }

    setTimeout(() => {
      this.$current.remove();
      this.$current = $(`#${id}`);
    }, 3000);

    if (!this.isSafari) {
      this.$current.addClass("hidden");
    }
    // this.$current.addClass("hidden");
    // TweenMax.fromTo(`#${id}`, 3,
    //   {opacity: 0},
    //   {opacity: 1, ease: Power1.easeOut, onComplete: () => {
    //
    //   }}
    // );

    setTimeout(() => {
      this.next();
    }, 7000);
  }
}



// WEBPACK FOOTER //
// ./src/js/modules/Slide.js